module.exports = __webpack_public_path__ + "static/media/thunder-alt.aca24dd7.svg";